function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("style", null, ".brands_svg__st0{fill:none;stroke:#000;stroke-width:inherit;stroke-linejoin:round;stroke-miterlimit:10}");

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "brands_svg__st0",
  d: "M11.706 6.505L5.501.3H3.575L.3 3.575v1.926l6.205 6.205z"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  className: "brands_svg__st0",
  cx: 3.409,
  cy: 3.409,
  r: 0.62
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "brands_svg__st0",
  d: "M3.092 2.876c.047.11.093.224.14.341C1.031 2.427.155.3 1.02.3c.402 0 .882.42 1.363 1.186m3.523 7.732l3.312-3.312M4.462 7.774l3.312-3.312"
});

function SvgBrands(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "brands_svg__Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 12.006 12.006",
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default SvgBrands;